import { ChucNang } from '@interfaces/common/menuInterfaces'

/**
 * Interface cho menu từ API (có thể khác với Menu interface trong database)
 */
interface MenuApiResponse {
    type?: string
    isActive?: boolean
    url?: string
    duongDan?: string
    loai?: string
    hoatDong?: boolean
    chucNangs: ChucNang[]
    [key: string]: any
}

/**
 * Hàm chính trả ra 3 đối tượng từ danh sách menu
 */
export const processWebMenu = (menus: MenuApiResponse[]) => {
    // Lọc menu mobile và active
    // Hỗ trợ cả type/isActive (từ API) và loai/hoatDong (từ database)
    const webMenus = menus.filter(menu => {
        const type = menu.type || menu.loai
        const isActive = menu.isActive !== undefined ? menu.isActive : menu.hoatDong
        return type === 'WEBAPP' && isActive
    })
    
    const webUrls = webMenus
        .map(menu => menu.url || menu.duongDan)
        .filter(url => url)
    
    const webChucNangs = webMenus
        .map(menu => ({
            url: menu.url || menu.duongDan || '',
            chucNangs: menu.chucNangs.map((chucNang: ChucNang) => chucNang.ma)
        }))
        .filter(item => item.url && item.chucNangs.length > 0)
    
    const webChucNangAll = webMenus
        .flatMap(menu => menu.chucNangs.map((chucNang: ChucNang) => chucNang.ma))
        .filter((value, index, self) => self.indexOf(value) === index)
    
    return {
        webUrls,
        webChucNangs,
        webChucNangAll
    }
}

